// Main JS entry point for esbuild

import './script.js';
import './modals.js';
// import './treatise/treatise.js'; // Removed treatise JS import

// Global state
let isFetching = false;
let currentConversationId = null;
let currentEventSource = null;

// Flag to track if the page was just loaded - to prevent unwanted EventSource initialization
let isPageFirstLoad = true;

// Add a log to confirm loading
console.log("Main JS bundle loaded.");

// Reset the unwanted EventSource initialization protection after a short delay
setTimeout(() => {
    isPageFirstLoad = false;
    console.log("Page load protection disabled, normal operation enabled");
}, 1000);

// DOM Elements
const proToggle = document.querySelector(".pro-mode-toggle");

// --- EventSource safety check ---
// This function should be called before any EventSource creation
// It will prevent creating EventSource objects with unsafe URLs
function safeCreateEventSource(url, options) {
    // If we're in the initial page load state, don't allow EventSource creation
    if (isPageFirstLoad) {
        console.warn("Prevented EventSource creation during initial page load");
        return null;
    }
    
    // Don't create EventSource for GET to /ask
    if (url === '/ask' || url.startsWith('/ask?')) {
        console.warn("Prevented unsafe EventSource creation with GET to /ask");
        return null;
    }
    
    // Only allow POST method for EventSource to /ask
    if ((url === '/ask' || url.startsWith('/ask?')) && (!options || options.method !== 'POST')) {
        console.warn("Prevented unsafe EventSource creation with non-POST method to /ask");
        return null;
    }
    
    // Safe to create EventSource
    return new EventSource(url, options);
}

// Function to handle displaying messages
function displayMessage(content, type, messageId = null, conversationId = null) {
    const messagesContainer = document.getElementById('chat-messages');
    let messageElement;

    if (messageId && document.getElementById(messageId)) {
        // Update existing AI message element
        messageElement = document.getElementById(messageId);
        // Find the content div within the message element
        const contentDiv = messageElement.querySelector('.message-content');
        if (contentDiv) {
            // Append new content chunk
            // Basic check to prevent appending the typing indicator itself
            if (!content.includes('<div class="typing-indicator"></div>')) {
                 // If the last content was the typing indicator, replace it
                 if (contentDiv.innerHTML.endsWith('<div class="typing-indicator"></div>')) {
                     contentDiv.innerHTML = contentDiv.innerHTML.replace(/<div class="typing-indicator"><\/div>$/, '') + content;
                 } else {
                    contentDiv.innerHTML += content;
                 }
            }
            // Add typing indicator back if stream is ongoing
            if (currentEventSource && currentEventSource.readyState === EventSource.OPEN && !contentDiv.innerHTML.endsWith('<div class="typing-indicator"></div>')) {
                contentDiv.innerHTML += '<div class="typing-indicator"></div>';
            }
        }
    } else {
        // Create new message element
        messageElement = document.createElement('div');
        messageElement.classList.add('message', type);
        if (messageId) {
            messageElement.id = messageId;
        }

        // Create the content div
        const contentDiv = document.createElement('div');
        contentDiv.classList.add('message-content');
        // Handle potential markdown (requires a library like marked.js)
        // For now, just setting text content or basic HTML
        contentDiv.innerHTML = content; // Use innerHTML to render typing indicator
        
        messageElement.appendChild(contentDiv);
        messagesContainer.appendChild(messageElement);

         // Add typing indicator if it's the start of an AI message stream
         if (type === 'ai' && currentEventSource && currentEventSource.readyState === EventSource.OPEN && !contentDiv.innerHTML.endsWith('<div class="typing-indicator"></div>')) {
            contentDiv.innerHTML += '<div class="typing-indicator"></div>';
        }
    }

    // Scroll to bottom
    scrollToBottom('chat-messages-wrapper');
    return messageElement; // Return the element for potential updates
}

// --- Helper function to process the response stream --- 
// MOVED TO SCRIPT.JS
/*
async function processStream(response, aiMessageElement) { 
    // ... function body ...
}
*/

// --- REMOVED Title Fetching and Citation Enhancement Functions ---
// These functions have been moved to script.js to avoid duplication

// Utility function to scroll to bottom
// MOVED TO SCRIPT.JS
/*
function scrollToBottom(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollTop = element.scrollHeight;
    }
}
*/

// Adjust textarea height dynamically
function autoGrowTextarea(element) {
    element.style.height = 'auto'; // Temporarily shrink to get scrollHeight
    element.style.height = (element.scrollHeight) + 'px';
}

// Add input event listeners to textareas if they exist
document.addEventListener('DOMContentLoaded', () => {
    // const searchInput = document.getElementById('question'); // <-- Comment out or remove
    const chatInput = document.getElementById('chat-input'); // Assuming ID for mobile chat

    // if (searchInput) { // <-- Comment out or remove
    //     searchInput.addEventListener('input', () => autoGrowTextarea(searchInput)); // <-- Comment out or remove
    // } // <-- Comment out or remove
    if (chatInput) {
        chatInput.addEventListener('input', () => autoGrowTextarea(chatInput));
    }
});

// ... rest of main.js ...
